import nl2br from '../../../../shared/nl2br'
import escapeHtml from 'escape-html'

export default {
  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Service">
      <ui-form-item label="Service Start Date">
        {{ model.service.startDate }}
      </ui-form-item>

      <ui-form-item label="Service Type">
        {{ model.service.type }}
      </ui-form-item>

      <ui-form-item label="Comments and/or Directions to New Construction (optional)">
        <span v-html="comments"></span>
      </ui-form-item>

      <ui-form-item label="Is there an Outdoor Light installed by REMC on the property?">
        {{ model.service.hasRemcOutdoorLight }}
      </ui-form-item>

      <ui-form-item label="Do you want the Outdoor Light connected?">
        {{ model.service.wantsOutdoorLight }}
      </ui-form-item>

      <ui-form-item label="Has the business ever had service with REMC before?">
        {{ model.service.previousService.hadService }}
      </ui-form-item>

      <template v-if="model.service.previousService.hadService === 'Yes'">
        <ui-form-item label="Previous Service Address">
          <span v-html="previousAddress"></span>
        </ui-form-item>
      </template>

      <ui-form-item label="What type of business is it?">
        {{ model.service.typeOfBusiness }}
      </ui-form-item>

      <ui-form-item label="Your preferred billing method">
        {{ model.service.preferredBillingMethod }}
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },

  computed: {
    comments() {
      return nl2br(escapeHtml(this.model.service.comments || ''))
    },

    previousAddress() {
      return nl2br(escapeHtml(this.model.service.previousService.address || ''))
    },
  },
}
